import { HttpClient } from "@angular/common/http";
import { UrlServidor } from "../util/url-servidor";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DanfeCsosn } from "../api/dto/danfe/danfe-csosn";

@Injectable({
    providedIn: 'root',
})
export class DanfeCsosnService {
    constructor(private http: HttpClient) { }
    private url : string = UrlServidor.URL_BASE + 'danfe-csosn';

    listar(): Observable<DanfeCsosn[]>{
        return this.http.get<DanfeCsosn[]>(this.url);
    }
}